import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

const stateWalletClosePath = {
	path: "/admin/transactions/smarthop-wallet-close",
	component: lazy(() => import("./TransactionsStateSmarthopWalletClosePage")),
};

export default build([...(false ? [stateWalletClosePath] : [])]); // TODO: WALLET_FEATURE gk
